import { Eye, EyeOff } from "lucide-react";

const when = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  if (mins < 60 * 24) return `${Math.round(mins / 60)} h ago`;
  return d.toLocaleString("en-AU", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
};

export const VisitBadge = ({ p }) => {
  if (!p?.firstVisitAt) {
    return (
      <p data-testid={`visit-status-${p?.slug}`} className="mt-3 inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-600">
        <EyeOff className="h-3.5 w-3.5" /> Not opened yet
      </p>
    );
  }
  const count = p.visitCount ?? 0;
  return (
    <div data-testid={`visit-status-${p.slug}`} className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs">
      <span className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 font-semibold text-emerald-800">
        <Eye className="h-3.5 w-3.5" /> First opened {when(p.firstVisitAt)}
      </span>
      <span className="text-slate-600">
        Last opened {when(p.lastVisitAt)} · {count} {count === 1 ? "visit" : "visits"}
      </span>
    </div>
  );
};
